import React, { useState } from 'react'
import "./Skills.scss"
import { motion } from 'framer-motion';
import { AppWrap } from '../../wrapper';

const skills = [
  {
    category: "Programming Languages",
    technologies: [
      { name: "JavaScript", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968292.png" },
      { name: "Python", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968350.png" },
      { name: "Java", icon: "https://img.icons8.com/color/48/000000/java-coffee-cup-logo--v1.png" },
      { name: "C++", icon: "https://cdn-icons-png.flaticon.com/512/6132/6132222.png" },
      { name: "C", icon: "https://img.icons8.com/color/48/000000/c-programming.png" },
      { name: "PHP", icon: "https://img.icons8.com/?size=100&id=f0R4xVI4Sc8O&format=png&color=000000" },
    ]
  },
  {
    category: "Frontend",
    technologies: [
      { name: "HTML", icon: "https://cdn-icons-png.flaticon.com/512/1051/1051277.png" },
      { name: "CSS", icon: "https://cdn-icons-png.flaticon.com/512/732/732190.png" },
      { name: "Tailwind CSS", icon: "https://play.tailwindcss.com/social-square.jpg" },
      {name: "Bootstrap", icon: "https://img.icons8.com/color/48/000000/bootstrap.png"},
    ]
  },
  {
    category: "Database",
    technologies: [
      { name: "MongoDB", icon: "https://www.pngall.com/wp-content/uploads/13/Mongodb-PNG-Image-HD.png" },
      { name: "MySQL", icon: "https://futuresolutionsonline.co.uk/wp-content/uploads/2023/04/mySQL-logo.png" },
      { name: "PostgreSQL", icon: "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg" },
    ]
  },
  {
    category: "Data Analysis & ML",
    technologies: [
      { name: "Jupyter Notebook", icon: "https://images.seeklogo.com/logo-png/35/1/jupyter-logo-png_seeklogo-354673.png" },
      { name: "Python", icon: "https://cdn-icons-png.flaticon.com/512/5968/5968350.png" },
    ]
  },
  {
    category: "Version Control",
    technologies: [
      { name: "Git", icon: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" },
      { name: "GitHub", icon: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" },
    ]
  },
  {
    category: "Operating Systems",
    technologies: [
      { name: "Linux", icon: "https://cdn-icons-png.flaticon.com/512/6124/6124995.png" },
    ]
  },
  {
    category: "CMS",
    technologies: [
      { name: "WordPress", icon: "https://img.icons8.com/color/48/000000/wordpress.png" },
    ]
  },
  {
    category: "Deployment",
    technologies: [
      { name: "Netlify", icon: "https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg" },
    ]
  },
]

const Skills = () => {
  const [filter, setFilter] = useState('All');

  const filteredSkills = skills.reduce((acc, category) => {
    const filteredTech = category.technologies.filter(tech =>
      filter === 'All' || category.category === filter
    );
    if (filteredTech.length > 0) {
      acc.push({ ...category, technologies: filteredTech });
    }
    return acc;
  }, []);

  const categories = ['All', ...new Set(skills.map(s => s.category))];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12">My <span className="text-blue-600">Tech Stack</span></h2>

        <div className="overflow-x-auto whitespace-nowrap scrollbar-hide mb-8">
          <div className="flex gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => setFilter(category)}
                className={`px-4 py-2 rounded-full transition-all duration-300 ${filter === category
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <motion.div
          layout
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {filteredSkills.map((category) => (
            <motion.div
              key={category.category}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">{category.category}</h3>
                <div className="grid grid-cols-3 gap-4">
                  {category.technologies.map((tech) => (
                    <motion.div
                      key={tech.name}
                      whileHover={{ scale: 1.05 }}
                      className="flex flex-col items-center text-center"
                    >
                      <div className="w-12 h-12 rounded-full overflow-hidden mb-2 bg-gray-100 flex justify-center items-center shadow-sm">
                        <img src={tech.icon} alt={tech.name} className="w-full h-full object-cover" />
                      </div>
                      <p className="text-xs text-gray-600 font-medium">{tech.name}</p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AppWrap(Skills, 'skills');